export default __webpack_public_path__ + "static/media/autobild-tenant-switcher.abf4c174.svg";